import { styled } from "@mui/material";

export const Spacer = styled("div")`
  flex: 1 1 100%;
`;
